var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600,
    viewBox: "0 0 180 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(0 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-5v5h3z",
    fill: "#fff",
    transform: "rotate(18 0 -5)",
    id: "a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(72)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cf142b",
      strokeWidth: 1
    },
    d: "M0 0h180v120H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 80h180V0H0Z",
    style: {
      fill: "#00247d",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc0",
      strokeWidth: 1
    },
    d: "M0 0h180v40H0Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .242)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(-70 105.507 -23.474) scale(1.0384)",
    width: "100%",
    height: "100%",
    style: {
      strokeWidth: 0.96302092
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(-45.934 147.37 -62.402) scale(1.0384)",
    width: "100%",
    height: "100%",
    style: {
      strokeWidth: 0.96302092
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(-30 205.59 -127.04) scale(1.0384)",
    width: "100%",
    height: "100%",
    style: {
      strokeWidth: 0.96302092
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(-10 537.7 -472.587) scale(1.0384)",
    width: "100%",
    height: "100%",
    style: {
      strokeWidth: 0.96302092
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 180.051 .242)",
    style: {
      display: "inline",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(-70 105.507 -23.474) scale(1.0384)",
    width: "100%",
    height: "100%",
    style: {
      strokeWidth: 0.96302092
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(-45.934 147.37 -62.402) scale(1.0384)",
    width: "100%",
    height: "100%",
    style: {
      strokeWidth: 0.96302092
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(-30 205.59 -127.04) scale(1.0384)",
    width: "100%",
    height: "100%",
    style: {
      strokeWidth: 0.96302092
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(-10 537.7 -472.587) scale(1.0384)",
    width: "100%",
    height: "100%",
    style: {
      strokeWidth: 0.96302092
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVe);
export default __webpack_public_path__ + "static/media/ve.ad3e42bd04776982de6e49f570e30337.svg";
export { ForwardRef as ReactComponent };